import HubSettings from "./HubSettings";
export default HubSettings;
